exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-01a3dd13] {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.homeBar[data-v-01a3dd13] {\n  width: 100%;\n  height: 100%;\n}\n#bar_horizontal[data-v-01a3dd13] {\n  width: 100%;\n  height: calc(100% - 5vh);\n  margin: auto;\n}\n", ""]);

// exports
